import React, { memo, useMemo } from 'react'
import {
  Box,
  Text,
  Button,
} from '@usap/uicomponents'
import VehicleImage from './VehicleImage'

import {
  Container,
  TextContainer,
  VehicleTitle,
  ChangeVehicle,
  BrowseContainer,
  SelectedVehicleTitlePlaceholder,
} from './Title.css'

const Title = ({
  title,
  vehicleImage,
  isVehicleImageLoading,
  selectedVehicle,
  isVLP,
  changeVehicle,
  navigateToVLP,
}) => {
  const containerMarginVLP = useMemo(() => (isVLP ? {} : { bottom: '14px' }), [isVLP])

  if (!title) return null

  return (
    <Container
      margin={containerMarginVLP}
    >
      <VehicleImage
        title={title}
        vehicleImage={vehicleImage}
        isVehicleImageLoading={isVehicleImageLoading}
        selectedVehicle={selectedVehicle}
      />
      <TextContainer>
        <VehicleTitle
          weight={900}
          color="dark-2"
        >
          {selectedVehicle && selectedVehicle.isPlaceholder ? (
            <SelectedVehicleTitlePlaceholder />
          ) : (
            <>
              {title}
            </>
          )}
        </VehicleTitle>
      </TextContainer>
      <Box direction="row" align="center">
        <ChangeVehicle id="changeVehicle">
          <Button
            id="changeVehicleBtn"
            custom
            hideBorder={false}
            label="Change Vehicle"
            onClick={changeVehicle}
          />
        </ChangeVehicle>
        {!isVLP && navigateToVLP && (
          <BrowseContainer id="browseParts">
            <Button
              id="browsePartsBtn"
              plain
              onClick={navigateToVLP}
              label={(
                <Text size="small" color="blueLink">
                  Browse parts
                </Text>
              )}
            />
          </BrowseContainer>
        )}
      </Box>
    </Container>
  )
}

export default memo(Title)
